import React from 'react';
import { useAppSelector } from '../../store';
import { selectUser } from '../../store/general/general-slice-selectors';
import { selectOrganizationsData } from '../../store/organization/organization-slice-selectors';
import UserRole from '../../models/enums/user-roles';
import OrganizationsForm from './OrganizationForm';
import { isNullOrWhiteSpace } from '../../utils/strings';

const OrganizationInitPopup: React.FC = () => {
  const user = useAppSelector((state) => selectUser(state));
  const organizationsData = useAppSelector((state) => selectOrganizationsData(state));

  if (
    organizationsData.current == null ||
    user.data.organization.id !== organizationsData.current.id ||
    user.data.role === UserRole.MEMBER ||
    user.data.role === UserRole.MODERATOR
  ) {
    return null;
  }

  return (
    <OrganizationsForm
      organization={organizationsData.current}
      parentId={organizationsData.current.parentId ?? ''}
      open={
        isNullOrWhiteSpace(organizationsData.current.address) ||
        isNullOrWhiteSpace(organizationsData.current.city) ||
        isNullOrWhiteSpace(organizationsData.current.zipCode)
      }
      role={organizationsData.current.role}
      initialization
      onClose={() => {}}
    />
  );
};

export default OrganizationInitPopup;
